import React from 'react';
import Modal from '../Modal';
import { PurchaseHistory } from 'ai-api/types/purchase';
import './PurchaseDetailsModal.scss';
import { formatDate } from '../../Utils/formatting';

interface PurchaseDetailsModalProps {
    isOpen: boolean;
    onClose: () => void;
    purchase: PurchaseHistory | null;
}

const PurchaseDetailsModal: React.FC<PurchaseDetailsModalProps> = ({
    isOpen,
    onClose,
    purchase
}) => {
    if (!purchase) return null;


    const getStatusLabel = (status: string) => {
        const statusLabels: Record<string, string> = {
            'created': 'Created',
            'waiting': 'Processing',
            'succeeded': 'Succeeded',
            'failed': 'Failed',
            'canceled': 'Canceled'
        };
        return statusLabels[status] || status;
    };

    // Only subscription purchases could have upcoming events
    const isUpcoming = purchase.status === 'succeeded' && purchase.type === 'subscription';

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="purchase-details-modal">
                <h2>Purchase Details</h2>
                
                <div className="details-section">
                    <h3>Product Information</h3>
                    <div className="product-info">
                        <div className="product-image">
                            <img src={'/feature1.png'} alt={purchase.productName} />
                        </div>
                        <div className="product-details">
                            <h4>{purchase.productName}</h4>
                            <p className="order-number">Order #{purchase.orderid && purchase.orderid.includes('_') ? purchase.orderid.split('_')[1] : purchase.orderid}</p>
                            <p className="order-date">Purchased on {formatDate(new Date(purchase.created_at * 1000).toISOString())}</p>
                            <p className="order-status">
                                Status: <span className={`status-${purchase.status}`}>{getStatusLabel(purchase.status)}</span>
                            </p>
                            <p className="product-type">
                                Type: <span className={`type-tag ${purchase.type}`}>
                                    {purchase.type.charAt(0).toUpperCase() + purchase.type.slice(1)}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                
                {purchase.type === 'subscription' && (
                    <div className="details-section">
                        <h3>Subscription Details</h3>
                        <div className="details-grid">
                            <div className="detail-item">
                                <span className="label">Type:</span>
                                <span className="value">Korean Language Session</span>
                            </div>
                            {purchase.remainder !== undefined && (
                                <div className="detail-item">
                                    <span className="label">Remaining:</span>
                                    <span className="value">{Math.floor(purchase.remainder / (60 * 60 * 24))} days</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                
                <div className="details-section">
                    <h3>Payment Information</h3>
                    <div className="details-grid">
                        {purchase.type === 'subscription' && (
                            <div className="detail-item">
                                <span className="label">Status:</span>
                                <span className="value">{purchase.status}</span>
                            </div>
                        )}
                        <div className="detail-item">
                            <span className="label">Order ID:</span>
                            <span className="value">{purchase.orderid}</span>
                        </div>
                        <div className="detail-item">
                            <span className="label">Product ID:</span>
                            <span className="value">{purchase.productid || 'N/A'}</span>
                        </div>
                    </div>
                </div>
                
                <div className="modal-actions">
                    {isUpcoming && (
                        <button className="btn btn-primary">
                            View Session
                        </button>
                    )}

                    {purchase.status === 'succeeded' && isUpcoming && (
                        <button className="btn btn-secondary">
                            Reschedule
                        </button>
                    )}

                    {purchase.status === 'succeeded' && isUpcoming && (
                        <button className="btn btn-danger">
                            Cancel
                        </button>
                    )}
                    
                    <button className="btn btn-outline" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default PurchaseDetailsModal;